export default function CCActive({ width = 26, height = 28, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 28"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M4.21849 18.4084L13 28L21.7815 18.4084L26 7.31332L22.4576 0H3.54242L0 7.31332L4.21849 18.4084Z"
                fill="#EAEAEA"
            />
            <path
                d="M13 19.7563L9.05664 14.2251L12.8203 16.4468L13 16.5522L13.1797 16.4468L16.9424 14.2251L13 19.7563Z"
                fill="black"
                stroke="black"
                strokeWidth="0.708311"
            />
            <path
                d="M8.28906 11.9131L13 4.14941L17.7119 11.9131L13 14.7451L8.28906 11.9131Z"
                fill="black"
                stroke="black"
                strokeWidth="0.708311"
            />
        </svg>
    );
}
